import React, { useEffect, useState } from "react";
import {
  getDropReasons,
  createDropReason,
  updateDropReason,
  deleteDropReason,
} from "../api";

export default function DropReasons() {
  const [reasons, setReasons] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [reasonName, setReasonName] = useState("");
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    loadReasons();
  }, []);

  async function loadReasons() {
    try {
      const res = await getDropReasons();
      setReasons(res.data);
    } catch (err) {
      console.log(err);
    }
  }

  async function saveReason() {
    if (!reasonName.trim()) return;

    try {
      if (editingId) {
        await updateDropReason(editingId, reasonName);
      } else {
        await createDropReason(reasonName);
      }

      await loadReasons();

      setReasonName("");
      setEditingId(null);
      setShowModal(false);
    } catch (err) {
      console.log(err);
    }
  }

  async function removeReason(id) {
    if (!window.confirm("Delete this reason?")) return;

    try {
      await deleteDropReason(id);
      await loadReasons();
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div style={{ padding: "30px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2>Drop Reasons</h2>

        <button
          onClick={() => {
            setEditingId(null);
            setReasonName("");
            setShowModal(true);
          }}
          style={{
            padding: "8px 16px",
            background: "#28a745",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
          }}
        >
          + Add Reason
        </button>
      </div>

      <table
        border="1"
        cellPadding="10"
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Reason</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>

        <tbody>
          {reasons.map((reason) => (
            <tr key={reason.id}>
              <td>{reason.id}</td>

              <td>{reason.reason}</td>

              <td>
                <button
                  onClick={() => {
                    setEditingId(reason.id);
                    setReasonName(reason.reason);
                    setShowModal(true);
                  }}
                  style={{
                    background: "#2563eb",
                    color: "#fff",
                    border: "none",
                    padding: "6px 14px",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  Edit
                </button>
              </td>

              <td>
                <button
                  onClick={() => removeReason(reason.id)}
                  style={{
                    background: "#dc2626",
                    color: "#fff",
                    border: "none",
                    padding: "6px 14px",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
            {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,.35)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "400px",
              background: "#fff",
              padding: "25px",
              borderRadius: "10px",
            }}
          >
            <h3>
              {editingId ? "Edit Drop Reason" : "Add Drop Reason"}
            </h3>

            <input
              value={reasonName}
              onChange={(e) => setReasonName(e.target.value)}
              placeholder="Reason"
              style={{
                width: "100%",
                padding: "10px",
                marginTop: "15px",
                marginBottom: "20px",
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                onClick={() => {
                  setShowModal(false);
                  setReasonName("");
                  setEditingId(null);
                }}
              >
                Cancel
              </button>

              <button
                onClick={saveReason}
                style={{
                  background: "#28a745",
                  color: "#fff",
                  border: "none",
                  padding: "10px 18px",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}